import {ActivatedRoute, NavigationStart, Router} from "@angular/router";
import {ApplicationRef, inject, Injectable, Injector} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class PopoutContentService {
  appRef = inject(ApplicationRef);
  private router = inject(Router);
  private injector = inject(Injector);
  private activatedRoute = inject(ActivatedRoute);


  opened: boolean = false;
  windowRef: WindowProxy | null | undefined;

  constructor() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.opened = event.url.includes('/files/');
      }
    })
  }

  open(url: string, title: string, inNewTab: boolean = false) {
    // if (inNewTab) {
    //   window.open(url, title, '_blank');
    //   return;
    // }

    this.windowRef = window.open(url, '_blank');

    // this.windowRef = window.open(url, title, 'width=1280,height=720');
  }

  close() {
    if (this.windowRef) {
      this.windowRef.close();
    }
    this.opened = false;
  }
}
